<template>
  <div>
    <div v-if="communitiesInfos" class="communitiesInfos">
      <div class="communities">
        <span class="number">{{ communitiesInfos.countCommunities }}</span>
        <span class="label">{{ $t('home.communitiesInfos.communities') }}</span>
      </div>
      <div class="usersPosts">
        <div><span class="number">{{ communitiesInfos.countUsers }}</span> {{ $t('home.communitiesInfos.users') }}</div>
        <div><span class="number">{{ communitiesInfos.countPosts }}</span> {{ $t('home.communitiesInfos.posts') }}</div>
      </div>
    </div>
    <div class="action">
      <div class="link hover-effect" @click="goToCommunities">
        <span>{{ $t('home.communitiesInfos.seeAllCommunities') }}</span>
      </div>
      <div class="link hover-effect" @click="goToMyCommunities">
        <span>{{ $t('home.communitiesInfos.seeMyCommunities') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommunitiesInfos',
  props: {
    communitiesInfos: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToCommunities() {
      this.$store.dispatch('filterCommunities', 'all')
      this.$router.push({ name: 'communitiesPage' })
    },
    goToMyCommunities() {
      this.$store.dispatch('filterCommunities', 'myCommunities')
      this.$router.push({ name: 'communitiesPage' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.communitiesInfos {
  display: flex;
  flex-direction: column;
  padding: 1rem;

  .communities {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    text-align: left;

    .number {
      height: 50px;
      font-size: 40px;
      font-weight: 600;
    }

    .label {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .usersPosts {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    text-align: left;

    .number {
      font-weight: 800;
    }
  }
}

.action {
  margin-top: -1rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;

  .link {
    color: $tertiary-color;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0.5rem 0.5rem 0 1rem;
    width: calc( 100% - 1.5rem);

    span:hover {
      //text-decoration: underline;
    }
  }
}
</style>
